<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
   <div>
       <div class="page-content">
           <div class="container-fluid">

               <div class="row">
                   <div class="col-12 mb-4">
                       <v-card>
                           <v-card-title>
                               Les utilisateurs
                               <v-spacer></v-spacer>
                               <v-text-field
                                       v-model="search"
                                       append-icon="mdi-magnify"
                                       label="Rechercher ..."
                                       single-line
                                       hide-details
                               ></v-text-field>
                           </v-card-title>
                           <v-data-table
                                   :headers="headers"
                                   :items="userspharmacies"
                                   :search="search"
                                   sort-by="name"
                                   class="elevation-1"
                                   :loading="userspharmacies.length==0" loading-text="Chargement en cours...">

                               <template v-slot:item.created_at="{item}">
                                   {{ getformatDate(item.created_at)}}
                               </template>
                               <template v-slot:top>
                                   <v-toolbar flat color="white">
                                       <v-spacer></v-spacer>
                                       <v-dialog v-model="dialog"  style="z-index: 9999" max-width="500px">
                                           <template v-slot:activator="{ on }">
                                               <v-btn style="background: #004F85;color: #fff" class="mb-2" v-on="on">Nouvel utilisateur
                                               </v-btn>
                                           </template>
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">{{ formTitle }}</span>
                                               </v-card-title>

                                               <v-card-text>


                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                       <v-alert v-if="errors" dense outlined
                                                                :type="(errors.update_error)?'error':'success'">
                                                           {{errors.operation}}
                                                       </v-alert>

                                                       <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                                                       <v-row>
                                                           <v-col cols="12" sm="6" md="12">
                                                               <v-text-field
                                                                       clearable :rules="nameRules" v-model="editedItem.name"
                                                                             label="Nom complet" placeholder="ex : Patrick SODJINNIN"></v-text-field>
                                                           </v-col>
                                                           <v-col cols="12" sm="6" md="12">
                                                               <v-text-field
                                                                       clearable :rules="emailRules" v-model="editedItem.email"
                                                                             label="Email" placeholder="ex : sodjinninpatrick@gmail.com"></v-text-field>
                                                           </v-col>

                                                           <v-col cols="12" sm="6" md="12">

                                                               <v-text-field
                                                                       :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                                       :type="show1 ? 'text' : 'password'"
                                                                       @click:append="show1 = !show1"
                                                                       clearable v-model="editedItem.password"
                                                                             label="Mot de passe" placeholder="******"></v-text-field>

                                                           </v-col>
                                                           <v-col cols="12" sm="6" md="12" >
                                                               <v-select :rules="roleRules" @change="roleChanged"   v-model="editedItem.role_id" item-text="nom" item-value="_id" :items="roles" label="Roles"  multiple
                                                               >
                                                                   <template v-slot:selection="{ item, index }">
                                                                       <v-chip v-if="index === 0">
                                                                           <span>{{ item.nom}}</span>
                                                                       </v-chip>
                                                                       <span
                                                                               v-if="index === 1"
                                                                               class="grey--text caption"
                                                                       >(+{{ editedItem.role_id.length - 1 }} others)</span>
                                                                   </template>

                                                               </v-select>
                                                           </v-col>
                                                       </v-row>
                                                   </v-form>
                                               </v-card-text>

                                               <v-card-actions>
                                                   <v-spacer></v-spacer>
                                                   <v-btn color="blue darken-1" text @click="close">Annuler</v-btn>
                                                   <v-btn color="blue darken-1"  :disabled="!valid" text @click="save">Sauvegarder</v-btn>
                                               </v-card-actions>
                                           </v-card>
                                       </v-dialog>
                                       <v-dialog v-model="update" max-width="500px">
                                           <v-card>
                                               <v-card-title>
                                                   <span class="headline">{{ formTitle }}</span>
                                               </v-card-title>

                                               <v-card-text>


                                                   <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                                                       <v-alert v-if="errors" dense outlined
                                                                :type="(errors.update_error)?'error':'success'">
                                                           {{errors.operation}}
                                                       </v-alert>

                                                       <v-text-field v-if="submitting" color="primary" loading
                                                                     disabled></v-text-field>
                                                       <v-row>
                                                           <v-col cols="12" sm="6" md="12">
                                                               <v-text-field
                                                                       clearable :rules="nameRules" v-model="editedItem.name"
                                                                             label="Nom complet" placeholder="ex : Patrick SODJINNIN"></v-text-field>
                                                           </v-col>
                                                           <v-col cols="12" sm="6" md="12">
                                                               <v-text-field
                                                                       clearable :rules="emailRules" v-model="editedItem.email"
                                                                             label="Email" placeholder="ex : sodjinninpatrick@gmail.com"></v-text-field>
                                                           </v-col>

                                                           <v-col cols="12" sm="6" md="12">

                                                               <v-text-field
                                                                       :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                                                                       :type="show1 ? 'text' : 'password'"
                                                                       @click:append="show1 = !show1"
                                                                       clearable v-model="editedItem.password"
                                                                             label="Mot de passe" placeholder="******"></v-text-field>

                                                           </v-col>
                                                       </v-row>
                                                   </v-form>
                                               </v-card-text>

                                               <v-card-actions>
                                                   <v-spacer></v-spacer>
                                                   <v-btn color="blue darken-1" text @click="closed">Annuler</v-btn>
                                                   <v-btn color="blue darken-1"  :disabled="!valid" text @click="updated">Sauvegarder</v-btn>
                                               </v-card-actions>
                                           </v-card>
                                       </v-dialog>
                                   </v-toolbar>
                               </template>
                               <template v-slot:item.actions="{ item }">
                                   <div v-if="item._id !== user._id">
                                    <div class="d-flex ">
                            <v-menu
                                    key="text"
                                    rounded="b-xl">
                                <template v-slot:activator="{ attrs, on }">
                                    
                                          <v-icon v-bind="attrs"
                                            v-on="on" color='primary'>mdi-dots-vertical</v-icon>
                                    
                                </template>
                                <v-list>
                                    <v-list-item
                                            v-for="(action_item, index) in actions_items"
                                            :key="index"
                                            link
                                            @click="editItemAction(item,index)">
                                        <v-list-item-content>
                                            <v-list-item-title v-text="action_item.title"></v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </div>
                                   </div>

                               </template>
                               <template v-slot:no-data>
                                   <v-btn color="default" @click="initialize">Actualiser</v-btn>
                               </template>
                           </v-data-table>
                       </v-card>
                   </div>
               </div>
               <v-snackbar
                       v-model="snackbar"
                       timeout="2000"
               >
                   {{ textSnack }}

                   <template v-slot:action="{ attrs }">
                       <v-btn
                               color="blue"
                               text
                               v-bind="attrs"
                               @click="snackbar = false"
                       >
                           Fermer
                       </v-btn>
                   </template>
               </v-snackbar>

           </div> <!-- container-fluid -->
       </div>
       <!-- End Page-content -->

   </div>
</template>

<script>
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    export default {
        name: "User",
        data() {
            return {
                submitting: false,
                valid: true,
                lazy: false,
                errors:undefined,
                search: '',
                dialog: '',
                update: '',
                roleHasChanged: false,
                id: undefined,
                snackbar: false,
                user: JSON.parse(localStorage.getItem("user")),
                roles:JSON.parse(localStorage.getItem("mineroles")),
                textSnack: '',
                show1: false,
                headers: [
                    {
                        text: 'Nom complet',
                        align: 'start',
                        sortable: true,
                        value: 'name',
                    },
                    {text: 'Email', value: 'email'},
                    {text: 'Ajouté le:', value: 'created_at'},
                    {text: 'Actions', value: 'actions', sortable: false},
                ],
                editedIndex: -1,
                editedItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                defaultItem: {
                    password: '',
                    email: '',
                    name: '',
                    _id: 0,
                    created_at: 0,
                },
                nameRules: [
                    v => !!v || 'Nom requis',
                    // v => (v && v.length <= 10) || 'Name must be less than 10 characters',
                ],
                emailRules: [
                    v => !!v || 'Email requis',
                ]
                ,
                passwordRules: [
                   v => !!v || 'Mot de passe requis',
                ],
                roleRules: [
                    v => !!v || 'Role requis',
                ],
                actions_items: [
                    { title: "Rôles" },
                    { title: "Modifier" },
                    { title: "Supprimer" }
                ],

            }
        }
        ,
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "Nouvel utilisateur" : "Mise à jour"
            }
            ,
            ...mapState('userspharmacies/', ['userspharmacies']),
            ...mapState('roles/', ['roles'])


        }
        ,
        mounted() {
        window.scrollTo(0,0);
            if (this.user.type_compte == "pharmacie")
            {
                if (!this.roles.includes("GU")){
                    this.$router.push("permission");
                }
            }
            let user = JSON.parse(localStorage.getItem("user"));
            console.log("User local2");
            console.log(user);
            this.$store.dispatch('userspharmacies/getUsersPharmacie',user.relation._id).then(response => {
                window.console.log('userspharmacies', response)
            });
            this.$store.dispatch('roles/getrole').then(response => {
                window.console.log('roles', response)
            });
        }
        ,
        watch: {
            dialog(val) {
                val || this.close()
            },
            update(val) {
                val || this.closed()
            },
        }
        ,
        methods: {
            initialize() {

            }
            ,
            roleChanged(){
                this.roleHasChanged = true;
            },
             editItemAction(item,index) {

               
                        switch (index){
                            case 0:
                                this.$router.push({ name: 'roleuser', params: { id: item._id } })
                                break;
                            case 1:
                                this.editItem(item);
                                break;
                            case 2:
                               this.deleteItem(item);
                                break;
                        }

                       

            },

            editItem(item) {
                this.editedIndex = this.userspharmacies.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.editedItem.password='';
                this.update = true;
            }
            ,

        getformatDate(value){
            if (value) {
                return Intl.DateTimeFormat('en-US',{
                    year: 'numeric',
                    month: 'short',
                    day: '2-digit',
                    hour: "numeric",
                    minute: "2-digit",
                    second: "2-digit"}).format(new Date(value));
            }
        },


        deleteItem(item) {
                Swal.fire({
                    icon: 'warning',
                    timerProgressBar: false,
                    text: "Êtes vous sûr(e) de vouloir supprimé ce élement?",
                    confirmButtonText: "Supprimer",
                    cancelButtonText: "Annuler",
                    showCancelButton: true
                }).then(result => {
                    if (result.value) {
                        this.$store.dispatch('userspharmacies/deleteUser', item._id).then((result) => {
                            console.log("del");
                            console.log(result);
                            this.snackbar = true;
                            this.textSnack = result.data.message;
                        });
                        let user = JSON.parse(localStorage.getItem("user"));
                        console.log("User local2");
                        console.log(user);
                        this.$store.dispatch('userspharmacies/getUsersPharmacie',user.relation._id).then(response => {
                            window.console.log('userspharmacies', response)
                        });
                    }
                })
            },

            closed() {
                this.update = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                });
                this.$refs.form.reset()
            },
            save() {
                this.submitting = true;
                let user = JSON.parse(localStorage.getItem("user"));
                let data = new FormData();
                data.append("email", this.editedItem.email);
                data.append("name", this.editedItem.name);
                data.append("password", this.editedItem.password);
                data.append("relation", user.relation._id);
                if ( this.roleHasChanged)
                data.append("role_id",JSON.stringify(this.editedItem.role_id));

                let mineroute = 'userspharmacies/setUser';
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.close();
                    }
                })
            },
            updated() {
                this.submitting = true;
                let user = JSON.parse(localStorage.getItem("user"));
                let data = new FormData();
                data.append("email", this.editedItem.email);
                data.append("name", this.editedItem.name);
                data.append("password", this.editedItem.password);
                data.append("relation", user.relation._id);
                data.append("id",this.editedItem._id);
                let mineroute = 'userspharmacies/setUpdateUser';
                console.log("ELE");
                console.log(this.editedItem);
                this.$store.dispatch(mineroute, data).then((response) => {
                    console.log('response', response);
                    this.snackbar = true;
                    this.textSnack = response.data.message;
                    this.submitting = false;
                    if (response.error) {
                        this.errors.operation = response.data.message;
                    } else {
                        this.closed();
                    }
                })
            },
            validate() {
                this.$refs.form.validate()
            },
            reset() {
                this.$refs.form.reset()
            },
            checkisDashboard() {
                this.$emit('checkisDashboard', true);
            }
        },
        created() {
            this.checkisDashboard();
            this.initialize()
        }

    }
</script>

<style scoped>

</style>